import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const ErrorPage = () => {
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState("Wystąpił nieznany błąd.");

    useEffect(() => {
        // Możesz tutaj spróbować wyodrębnić wiadomość o błędzie, jeśli jest przekazywana
        // np. z obiektu 'state' z react-router-dom, lub z parametrów URL.
        // Na razie jest to proste.
        if (location.state && location.state.errorMessage) {
            setErrorMessage(location.state.errorMessage);
        }
    }, [location.state]);

    return (
        // Używamy klasy .container, aby strona błędu miała ten sam wygląd i wyśrodkowanie
        <div className="container">
            <h1 style={{ color: '#dc3545' }}>Ups! Coś poszło nie tak.</h1> {/* Czerwony kolor dla tytułu błędu */}
            <p className="error-message">{errorMessage}</p> {/* Klasa do stylizacji wiadomości o błędzie */}
            <p>Możesz wrócić na stronę <Link to="/home" className="button-link">główną</Link> lub sprawdzić <Link to="/my-exams" className="button-link">moje egzaminy</Link>.</p>
        </div>
    );
};

export default ErrorPage;